import useAppQuery from 'core/query-client/useAppQuery';
import { getProjects } from 'shared/api/projects/http';

const useProjectsQuery = (payload) => useAppQuery(['projects', payload], () => getProjects(payload));

export default useProjectsQuery;
